import { Box, Text } from "@chakra-ui/react";
import { ComponentProps, PropsWithChildren } from "react";

export function FunnelStepSection({
  title,
  titleStyle,
  children,
  ...props
}: FunnelStepContentProps) {
  return (
    <Box
      p={{
        base: 4,
        sm: 8,
      }}
      borderRadius="lg"
      bg="greyscale.300"
      borderTopLeftRadius="0"
      {...props}
    >
      {title && (
        <Text
          fontSize="lg"
          fontWeight="medium"
          lineHeight="base"
          mb={children ? 4 : 0}
          {...titleStyle}
        >
          {title}
        </Text>
      )}
      {children}
    </Box>
  );
}

type FunnelStepContentProps = {
  title?: string;
  titleStyle?: ComponentProps<typeof Text>;
  dataTestId?: string;
} & PropsWithChildren &
  ComponentProps<typeof Box>;
